<template>
  <div>
    <span
      id="mentorship-type"
      :style="mentorshipTypeColor"
      class="font-weight-bolder text-primary"
    >
      {{ mentorshipType ? $t(mentorshipType) : '' }}
    </span>
  </div>
</template>

<script>

export default {
  components: {

  },
  props: {
    sessions: {
      type: Number,
      required: true,
    },
  },
  computed: {
    mentorshipType() {
      if (this.sessions === 6) {
        return '6-month'
      }
      if (this.sessions === 3) {
        return '3-month'
      }
      return null
    },
    mentorshipTypeColor() {
      if (this.sessions === 6) {
        return {
          background: 'rgba(212, 104, 120, 0.12)',
          color: 'rgb(212, 104, 120)',
        }
      }
      if (this.sessions === 3) {
        return {
          background: 'rgba(235, 103, 47, 0.12)',
          color: 'rgb(235, 103, 47)',
        }
      }
      return {}
    },
  },
}
</script>

<style lang="scss" scoped>
#mentorship-type {
  padding: 5px;
  font-size: 14px;
}
</style>
